import { Button, ButtonProps } from '@tuic/web-compositions/core/Button';
import { ButtonGroup } from '@tuic/web-compositions/core/ButtonGroup';
import { HeaderSection } from '@tuic/web-compositions/shared/HeaderSection';
import { LoadingSpinner } from '@tuic/web-compositions/core/LoadingSpinner';
import { Alert, AlertProps } from '@tuic/web-compositions/core/Alert';
import { FC, ReactNode } from 'react';
import { DialogBody } from '@modules/get-slash-internet-card/components/dialog-views/dialog-body';
type Props = {
  indicating?: boolean;
  connectionTag?: ReactNode;
  progressBar?: ReactNode;
  alert?: AlertProps;
  centered?: boolean;
  title?: ReactNode;
  text?: ReactNode;
  buttons?: ButtonProps[];
  customVariant?: ButtonProps['variant'];
};
export const GeneralView: FC<Props> = props => {
  const {
    title,
    text,
    buttons,
    centered,
    connectionTag,
    progressBar,
    alert,
    indicating,
    customVariant
  } = props;
  if (indicating) {
    return <div className="py-10 text-center text-marine-40">
        <LoadingSpinner size="lg" className="inline-block" />
      </div>;
  }
  return <DialogBody data-sentry-element="DialogBody" data-sentry-component="GeneralView" data-sentry-source-file="general-view.tsx">
      {connectionTag && <div className="mx-auto">{connectionTag}</div>}

      <HeaderSection headline={title} subline={text} centered={centered} data-sentry-element="HeaderSection" data-sentry-source-file="general-view.tsx" />

      {progressBar}

      {alert && <Alert {...alert} />}

      {buttons && buttons.length > 0 && <ButtonGroup orientation={centered ? 'horizontal-center' : 'horizontal'}>
          {buttons.map((button, idx) => <Button key={idx} {...button} variant={customVariant ?? button.variant} />)}
        </ButtonGroup>}
    </DialogBody>;
};